import { render } from "./AddProductSegment.vue?vue&type=template&id=00359ed1&scoped=true"
import script from "./AddProductSegment.vue?vue&type=script&lang=js"
export * from "./AddProductSegment.vue?vue&type=script&lang=js"

import "./AddProductSegment.vue?vue&type=style&index=0&id=00359ed1&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00359ed1"]])

export default __exports__